import React from 'react';
import { useDarkBody } from '../hooks';


function About() {
  useDarkBody()
    return (
      <div className="view">
        <div className="content">
          <div className="content--inner">
          <h2>Michael Schmidt</h2>
          <div className="sub-text">Frontend Developer & Musician</div>

          <p>I like designing and developing Webpages and blasting some Beats!</p>
          </div>
        </div>
      </div>
    );
}

export default About



// WEBPACK FOOTER //
// ./src/views/About.js